import { fetchTracker } from './queries'
import GeolocationTracker from '../../models/geolocation-tracker'
import { objectKeysToCamelCase } from '../../common/case-style-conversion'

export const findTracker = async (id, after, before) => {
  const trackerInfo = await fetchTracker(id, after, before)
  return GeolocationTracker.one(objectKeysToCamelCase(trackerInfo))
}
